import React, { useState } from 'react';
import Span from '../Element/Span/Span';
import Icon from '../Icon/Icon';
import BreadcrumbItem, {
  BreadcrumbItemProps,
} from './BreadcrumbItem/BreadcrumbItem';
import { CommonProps } from '../Element/Element';
import Typography from '../Typography/Typography';
import style from './Breadcrumb.module.scss';
import { OptionListOption } from '../OptionList/OptionList';
import Element from '../Element/Element';
import BreadcrumbTruncatedItems from './BreadcrumbTruncatedItems/BreadcrumbTruncatedItems';
type BreadcrumbProps = {
  /** List of breadcrumb items*/
  items: BreadcrumbItemProps[];
  /** Truncates breadcrumbs */
  truncated?: boolean;
} & CommonProps<'nav'>;

const Separator = () => {
  return (
    <Span aria-hidden inlineBlock padding={{ horizontal: 'xs' }}>
      <Icon name="chevron-right" color="black" size="xs" />
    </Span>
  );
};

const Breadcrumb: React.FunctionComponent<BreadcrumbProps> = ({
  truncated,
  items,
  ...props
}) => {
  const [open, setOpen] = useState(false);
  const renderItems = (items: BreadcrumbItemProps[]): JSX.Element[] => {
    return items.map((item, index) => {
      if (index == items.length - 1) {
        return (
          <Typography
            key={item.value}
            font="teliasans"
            uppercase={false}
            fontWeight="medium"
            color="gray800"
            className={style.breadcrumb_currentPage}
            {...item}
          >
            {item.label}
          </Typography>
        );
      }
      return (
        <React.Fragment key={index}>
          <BreadcrumbItem
            key={item.value}
            onKeyPress={(e) => {
              e.key === 'Enter' && item.onClick();
            }}
            {...item}
          />
          <Separator />
        </React.Fragment>
      );
    });
  };

  const renderItemsTruncated = (items: BreadcrumbItemProps[]): JSX.Element => {
    const firstItem = items[0];
    const optionListItems = items.slice(1, items.length - 2).map((item) => ({
      label: item.label,
      value: item.value,
    }));
    const lastTwoItems = items.slice(items.length - 2);

    const optionOnClickHandler = (option: OptionListOption) => {
      setOpen(false);
      const selectedOption = items.filter(
        (item) => item.value == option.value
      )[0];
      selectedOption.onClick && selectedOption.onClick();
    };

    return (
      <>
        <BreadcrumbItem
          onKeyPress={(e) => {
            e.key === 'Enter' && firstItem.onClick();
          }}
          {...firstItem}
        />
        <Separator />
        <BreadcrumbItem
          truncateToggle
          value="telia-react-component-library-truncated-items"
          label={'...'}
          onClick={() => {
            setOpen(!open);
          }}
          onKeyPress={(e) => {
            e.key === 'Enter' && setOpen(!open);
          }}
        >
          {!!open && (
            <span className={style.breadcrumb_truncated_toggle}>
              <BreadcrumbTruncatedItems
                onClose={() => {
                  setOpen(false);
                }}
                className={style.breadcrumb_optionList}
                optionOnClick={(e, option: OptionListOption) => {
                  optionOnClickHandler(option);
                }}
                options={optionListItems}
              ></BreadcrumbTruncatedItems>
            </span>
          )}
        </BreadcrumbItem>
        <Separator />
        {renderItems(lastTwoItems)}
      </>
    );
  };

  return (
    <Element tagName={'nav'} {...props}>
      {truncated ? renderItemsTruncated(items) : renderItems(items)}
    </Element>
  );
};

export default Breadcrumb;
